import CartActionPopUpV2 from './CartActionPopUpV2';

export default CartActionPopUpV2;
